module.exports = __webpack_public_path__ + "media/images/preview-eye-7707aadbb10184f297ac648fdc561493.svg";